import { ItemDetailsProps } from '../../commons/components/ItemListAndDetails';
import {
  SURVEY_ITEM_FINANCIAL_ANALYSIS,
  SURVEY_ITEM_INTRO,
  SURVEY_ITEM_REVIEW,
  SURVEY_ITEM_SECTION,
  SURVEY_ITEM_VARIABLES,
  SurveyItemViewModel,
} from '../types';
import { SurveySection, SurveySectionActionPayload } from './SurveySection';
import React from 'react';
import { BusinessPlanReview } from './BusinessPlanReview';
import { SurveyVariables } from './SurveyVariables';
import { BusinessPlanIntro } from './BusinessPlanIntro';
import { FinancialAnalysis } from './FinancialAnalysis';

export const SurveyItem = (
  props: ItemDetailsProps<SurveyItemViewModel, SurveySectionActionPayload>
) => {
  const { item, onNavigateTo } = props;
  switch (item.type) {
    case SURVEY_ITEM_INTRO:
      return <BusinessPlanIntro onNavigate={onNavigateTo} />;
    case SURVEY_ITEM_VARIABLES:
      return <SurveyVariables />;
    case SURVEY_ITEM_SECTION:
      return <SurveySection {...props} item={item} />;
    case SURVEY_ITEM_FINANCIAL_ANALYSIS:
      return <FinancialAnalysis />;
    case SURVEY_ITEM_REVIEW:
      return (
        <BusinessPlanReview
          surveyVersion={item.version}
          dataTest="business-plan__download-button"
        />
      );
  }
};
